const BaseXform = require('../base-xform');

// Alignment encapsulates translation from style.alignment model to/from xlsx
class CellStyleXform extends BaseXform {
  get tag() {
    return 'cellStyle';
  }

  parseOpen(node) {
    this.model = {
        name: node.attributes.name,
        xfId: node.attributes.xfId,
        builtinId: node.attributes.builtinId,
    };
    return true;
  }

  parseText() {}

  parseClose() {
    return false;
  }
}

module.exports = CellStyleXform;
